// extracted by mini-css-extract-plugin
export default {"PostActions":"PostActions_PostActions__97m-R","PostActions__Action":"PostActions_PostActions__Action__D2A8s"};